import RowButton from 'components/atoms/row-button'
import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  buttonSelectText    : PropTypes.string,
  buttonSelectColour  : PropTypes.string,
  onButtonSelectClick : PropTypes.func
}

/**
 * Columns definition for Cms Blog Post Table
 * @param {string} buttonSelectText - The text that appears at the button on each row
 * @param {string} buttonSelectColour - Bootstrap button type class name (eg. primary)
 * @param {Function} onButtonSelectClick - function that will run when the button is clicked
 */
const urlRewriteTableColumns = ({
  buttonSelectText,
  buttonSelectColour,
  onButtonSelectClick
}) => {

  // eslint-disable-next-line react/prop-types
  const SelectActionCell = ({ cell: { row } }) => (
    <RowButton
      // eslint-disable-next-line react/prop-types
      data={ row.original }
      color={ buttonSelectColour }
      disabled={ false }
      onClick={ onButtonSelectClick }
      text={ buttonSelectText }
    />
  )


  return (
    [
      {
        Header         : 'Id',
        accessor       : 'id',
        disableFilters : true
      },
      {
        Header   : 'Old Path',
        accessor : 'old_path'
      },
      {
        Header   : 'New Path',
        accessor : 'new_path'
      },
      {
        Header : 'Action',
        id     : 'action',
        Cell   : SelectActionCell
      }
    ]
  )
}

urlRewriteTableColumns.propTypes = propTypes

export default urlRewriteTableColumns
